export const DONATION_HEADER_TOP_HEIGHT = 82;
export const DONATION_HEADER_BOTTOM_HEIGHT = 56;

// 수정시 $desktop-header-height도 변경
export const DONATION_HEADER_HEIGHT =
  DONATION_HEADER_TOP_HEIGHT + DONATION_HEADER_BOTTOM_HEIGHT;
